import axios from "axios";
// import environment from "../../environments/environments";
import { environment } from "../../environments/environments";
import Swal from "sweetalert2";

const baseURL = environment.baseURL;
console.log("baseURL//", baseURL);
const axiosInstance = axios.create({
  baseURL,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
  },
});

export const getData = async (endPoint, params = {}) => {
  try {
    const response = await axiosInstance.get(endPoint, { params });
    // console.log("getresponse", response);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const postData = async (endPoint, data = {}) => {
  try {
    const response = await axiosInstance.post(endPoint, data);
    console.log("response", response);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// const handleError = (error) => {
//   return Alert.alert(
//     "Error!",
//     error?.response?.data && typeof error?.response?.data !== "object"
//       ? error?.response?.data
//       : "Something went wrong, please try again later",
//     [{ text: "OK" }]
//   );
//   return Alert.alert(
//     "Error!",
//     error?.response?.data && typeof error?.response?.data === ""
//       ? error?.response?.data
//       : "Something went wrong, please try again later",
//     [{ text: "OK" }]
//   );
// };
const handleError = (error) => {
  Swal.fire({
    icon: "error",
    title: "Error!",
    text:
      error?.response?.data && typeof error?.response?.data !== "object"
        ? error?.response?.data
        : "Something went wrong, please try again later",
    confirmButtonText: "OK",
  });
};

export default axiosInstance;
